import { render, staticRenderFns } from "./mrs-world.vue?vue&type=template&id=237aba5e&scoped=true&"
import script from "./mrs-world.vue?vue&type=script&lang=js&"
export * from "./mrs-world.vue?vue&type=script&lang=js&"
import style0 from "./mrs-world.vue?vue&type=style&index=0&id=237aba5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237aba5e",
  null
  
)

export default component.exports